export const GET_PROPERTY_TYPES = 'GET_PROPERTY_TYPES';

